export default "__VITE_ASSET__DS1lTr_w__"